import { TOB_IFRAME_URL_SET_COOKIE, TOB_TARGET_ORIGIN } from '../../../config';
import { MessageIframe } from '../../message-type/message-iframe';
export var getEnterpriseAccountSwitchEventName = {
    ALREADY_JUMP_B_IFRAME: 'ALREADY_JUMP_B_IFRAME', // B侧iframe已挂载监听器
    B_PAGE_SET_COOKIE: 'B_PAGE_SET_COOKIE', // 设置B侧登录态
    SUCCESS_SET_COOKIE: 'SUCCESS_SET_COOKIE', // 成功设置完B侧登录态
};
var TARGET_ORIGIN = TOB_TARGET_ORIGIN;
var B_DOMAIN = 'B_DOMAIN';
var IFRAME_URL = TOB_IFRAME_URL_SET_COOKIE;
var IFRAME_ID = 'iframe-to-b-set-cookie';
var SwitchEnterpriseAccountMessage = /** @class */ (function () {
    function SwitchEnterpriseAccountMessage() {
        this.iframeMountMessage = new MessageIframe(this.getIframeMountMessageCheckFn);
        this.switchAccountMessage = new MessageIframe(this.getSwitchAccountMessageCheckFn);
    }
    SwitchEnterpriseAccountMessage.prototype.connect = function () {
        this.iframeMountMessage.connect();
        this.switchAccountMessage.connect();
    };
    SwitchEnterpriseAccountMessage.prototype.dispose = function () {
        this.iframeMountMessage.dispose();
        this.switchAccountMessage.dispose();
    };
    SwitchEnterpriseAccountMessage.prototype.createSwitchEnterpriseAccount = function (hadMountCallback) {
        var _this = this;
        this.switchAccountDom = this.createMessageIframe(function (iframeDom, hadMountFirst) {
            if (!hadMountFirst) {
                hadMountCallback === null || hadMountCallback === void 0 ? void 0 : hadMountCallback();
                return;
            }
            _this.switchAccountMessage.setIframeDom(iframeDom, TARGET_ORIGIN);
        });
    };
    /**
     * 获取iframe加载完成信息
     * @param listener 监听器
     */
    SwitchEnterpriseAccountMessage.prototype.getIframeMountMessage = function (listener) {
        this.iframeMountMessage.receive(listener);
    };
    /**
     * 获取切换账号成功
     * @param listener 监听器
     */
    SwitchEnterpriseAccountMessage.prototype.getSwitchAccountMessage = function (listener) {
        this.switchAccountMessage.receive(listener);
    };
    /**
     * 发送切换账号请求
     * @param cookie
     */
    SwitchEnterpriseAccountMessage.prototype.sendSwitchAccountMessage = function (cookie) {
        this.switchAccountMessage.send({
            event: getEnterpriseAccountSwitchEventName.B_PAGE_SET_COOKIE,
            cookie: cookie,
            fromDomain: B_DOMAIN,
        });
    };
    SwitchEnterpriseAccountMessage.prototype.createMessageIframe = function (hadMountCallback) {
        if (document.getElementById(IFRAME_ID)) {
            hadMountCallback(document.getElementById(IFRAME_ID), false);
        }
        var iframe = document.createElement('iframe');
        iframe.src = IFRAME_URL;
        iframe.id = IFRAME_ID;
        iframe.style.visibility = 'hidden';
        iframe.style.width = '0px';
        iframe.style.height = '0px';
        document.body.appendChild(iframe);
        hadMountCallback(iframe, true);
        return iframe;
    };
    SwitchEnterpriseAccountMessage.prototype.getIframeMountMessageCheckFn = function (message) {
        var data = message.data, origin = message.origin;
        if (origin === TARGET_ORIGIN
            && data.event === getEnterpriseAccountSwitchEventName.ALREADY_JUMP_B_IFRAME) {
            return true;
        }
        return false;
    };
    SwitchEnterpriseAccountMessage.prototype.getSwitchAccountMessageCheckFn = function (message) {
        var data = message.data, origin = message.origin;
        if (origin === TARGET_ORIGIN
            && data.event === getEnterpriseAccountSwitchEventName.SUCCESS_SET_COOKIE) {
            return true;
        }
        return false;
    };
    return SwitchEnterpriseAccountMessage;
}());
export { SwitchEnterpriseAccountMessage };
